import { Button, Drawer, Grid, Layout, theme } from 'antd'
import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'

import PageLoader from '@components/PageLoader'
import { useAuth } from '@hooks/useAuth'
import { ListIcon } from '@phosphor-icons/react'

import { NavigationMenu } from './NavigationMenu'

const { Header, Sider, Content } = Layout

export const AuthenticatedLayout: React.FC = () => {
    const { user } = useAuth()
    const screens = Grid.useBreakpoint()
    const [drawerOpen, setDrawerOpen] = useState(false)

    const {
        token: { colorBgContainer, borderRadiusLG }
    } = theme.useToken()

    // Adding is loading here just so we don't forget it. Need a loading state for board list :)
    if (!user) {
        return <PageLoader />
    }

    // useBreakpoint returns {} on first render, so treat "unknown" as desktop to avoid a flash
    const isMobile = screens.md === false

    return (
        <Layout style={{ minHeight: '100vh' }}>
            {isMobile ? (
                <Drawer
                    placement="left"
                    open={drawerOpen}
                    onClose={() => setDrawerOpen(false)}
                    size={240}
                    closable={false}
                    styles={{ body: { padding: 0, background: '#001529' } }}
                >
                    <NavigationMenu onNavigate={() => setDrawerOpen(false)} />
                </Drawer>
            ) : (
                <Sider collapsible breakpoint="lg">
                    <NavigationMenu />
                </Sider>
            )}
            <Layout>
                {isMobile && (
                    <Header
                        style={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 10,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                            padding: '0 16px'
                        }}
                    >
                        <Button
                            type="text"
                            aria-label="Open navigation"
                            icon={<ListIcon size={24} color="#fff" />}
                            onClick={() => setDrawerOpen(true)}
                        />
                        <span style={{ color: '#fff', fontWeight: 700 }}>Admin</span>
                    </Header>
                )}
                <Content
                    style={{
                        margin: isMobile ? 8 : '24px 16px',
                        padding: isMobile ? 12 : 24,
                        minHeight: 280,
                        minWidth: 0,
                        background: colorBgContainer,
                        borderRadius: borderRadiusLG
                    }}
                >
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    )
}
